<template>
<div>
 <v-container>
 <v-layout mt-3 px-5 class="text-xs-center" row wrap>
      <v-flex xs12>
        <!--
        <v-avatar size="250" color="grey lighten-4">
          <img
            src="https://scontent-nrt1-1.xx.fbcdn.net/v/t1.0-9/50988163_10213734001079444_2817855097181044736_n.jpg?_nc_cat=104&_nc_ht=scontent-nrt1-1.xx&oh=d558e14acbf714985470fb4b740c35a8&oe=5D357E65"
            alt="avatar"
          >
        </v-avatar>
        -->
        <div class="midashi">
          <div>競馬予想サイトの無料予想を本気で検証してみた！</div>
          <div>無料で稼げるサイト教えます！！!</div>
        </div>
        <br>
        <p class="headline font-weight mt-2">当サイトについて</p>
        <p class="title font-weight-thin mt-3" >ご訪問いただきありがとうござます。</p>
        <p class="title font-weight-thin mt-3" >このページは私が様々なサイトの無料競馬予想を使ってなんとか お小遣い稼ぎをできないかと思い、立ち上げました。</p>
        <p class="title font-weight-thin mt-3" >2020年の9月の下旬より、約18サイトに登録して 無料情報を収集し、収支結果の検証をしております。</p>
        <p class="title font-weight-thin mt-3" >この18サイトは私が口コミ等を漁りまくって、無料予想に実績がありそうなサイトをピックアップしております。</p>
        <p class="title font-weight-thin mt-3" >当サイトの方針として月単位で上位3サイトぐらいをランキングでご紹介する予定です。</p>
        <p class="title font-weight-thin mt-3" >これは管理人なりの配慮で、無料情報の精度は低く、当たらないことがほとんどという前提の中で無料情報を提供していただいているサイトの評判を落とすようなことはしたくないからです。有料情報ならまだしも、無料ですからね！ 私も競馬を数十年やっておりますが、その瞬間だけの結果で評価されるのは困ります。従いまして、すべてのランキングを載せることはございません。あくまでも上位3つぐらいを目処にしております。回収率のランキングです。</p>
        <p class="title font-weight-thin mt-3" >競馬予想というものはトータルで見てどの程度なのかという視点で考える必要があると思っています。</p>
        <p class="title font-weight-thin mt-3" >「じゃあ、1年間のトータルで」としてしまうといつまでたっても検証結果を公開できないので、1ヶ月単位にしました。</p>
        <p class="title font-weight-thin mt-3" >また、検証にあたりマイルールというものを設けております。詳しくはランキングページでご確認いただければ幸いです。</p>
        <p class="title font-weight-thin mt-3" >前置きが長くなりましたが、ただ単純に競馬の無料情報ってあたるの？っていう観点でお楽しみいただければと思います。</p>
      </v-flex>
    </v-layout>
  </v-container>
  </div>
</template>

<script>
export default {
  name: 'TabHome', 
  components: {
  },
  data () {
  return {
      message:` `
    }
  },
}
</script>

<style lang="scss" scoped>
.midashi {
  font-size: 32px;
  color: #364e96;/*文字色*/
  padding: 0.5em 0;/*上下の余白*/
  border-top: solid 3px #364e96;/*上線*/
  border-bottom: solid 3px #364e96;/*下線*/
}
</style>